import { useCallback, useMemo } from 'react';
import { EntityDeleteModal } from '../../common/EntityActions/EntityDeleteModal';
import { useDeleteActions } from './useDeleteActions';

type DeleteSurvey = {
  beginDeleteSurvey: () => void;
  deleteSurveyModal: JSX.Element | null;
};

export const useDeleteSurvey = (
  surveyId: number | undefined,
  surveyName: string | undefined,
  onSuccess?: () => void,
): DeleteSurvey => {
  const { beginDelete, isDeleteConfirmed, isDeleteInProgress, continueDelete, cancelDelete } =
    useDeleteActions(onSuccess);

  const deleteSurveyModal = useMemo(
    () =>
      isDeleteInProgress ? (
        <EntityDeleteModal
          entityType="survey"
          entityName={surveyName}
          isOpen
          isDeletePending={isDeleteConfirmed}
          onDelete={continueDelete}
          onClose={cancelDelete}
        />
      ) : null,
    [cancelDelete, continueDelete, isDeleteConfirmed, isDeleteInProgress, surveyName],
  );

  const beginDeleteSurvey = useCallback(() => {
    if (surveyId === undefined) throw new Error('Survey ID is undefined');
    beginDelete(surveyId);
  }, [beginDelete, surveyId]);

  return useMemo(
    () => ({ beginDeleteSurvey, deleteSurveyModal }),
    [beginDeleteSurvey, deleteSurveyModal],
  );
};
